/**
 * Sub-accounts vuex store
 */

import { feathers } from '@/feathers-client';

export default {
  namespaced: true,
  state: {
    subAccounts: [],
  },
  getters: {
    subAccountsInfo: state => {
      return state.subAccounts.map(subAccount => {
        const { user } = subAccount;
        return {
          text: `${user.first_name} ${user.last_name}`,
          value: user.id,
        };
      });
    },
  },
  mutations: {
    setSubAccounts(state, subAccounts) {
      state.subAccounts = subAccounts;
    },
  },
  actions: {
    // find all subaccounts - users that you can share a contact with
    async findSubAccounts({ commit }, options = {}) {
      try {
        const query = Object.assign({ $paginate: false }, options);
        const subAccounts = await feathers.service('sub-accounts').find({ query });
        commit('setSubAccounts', subAccounts);
      } catch (err) {
        // todo cc redo this once backend change to get rid of 403 error is merged in
        commit('setSubAccounts', []);
        if (err.code >= 500) console.log(err);
      }
    },
  },
};
